import { OrgDestinationsResponse } from '../types/summaryView';

export const FETCH_ORG_DESTINATIONS_AND_VERSIONS_SUCCESS = 'FETCH_ORG_DESTINATIONS_AND_VERSIONS_SUCCESS';

export interface OrgDestinationsAndVersionsResponse {
    orgId: string;
    data: OrgDestinationsResponse;
}

export interface FetchOrgDestinationsAndVersionsSuccessAction {
    type: typeof FETCH_ORG_DESTINATIONS_AND_VERSIONS_SUCCESS;
    payload: OrgDestinationsAndVersionsResponse;
}

export const fetchOrgDestinationsAndVersionsSuccess = (
    payload: OrgDestinationsAndVersionsResponse,
): FetchOrgDestinationsAndVersionsSuccessAction => ({
    type: FETCH_ORG_DESTINATIONS_AND_VERSIONS_SUCCESS,
    payload,
});
